import { IconName, TextInputProps } from '@infotech-soe/erp-ui-kit';
import { TUpdaterName } from '@infotech-soe/metaschema';
import { ConnectedProps, legacy_connect as connect } from 'react-redux';

import { CategoryOpenMode } from '../../../models/category/category';
import { DictionaryTreeFormControlViewModel } from '../../../services/form/view-model/FormControlViewModel';
import UniqueId from '../../../services/uid/UniqueId';
import categoryActions from '../../../store/slices/category';
import { DictionaryEffectType } from '../../../store/slices/dictionary';
import LookupBox from '../LookupBox';

import { RequiredHistoryProps } from './hoc/HistoryContainer';

interface Props
  extends
    RequiredHistoryProps,
    Pick<
      DictionaryTreeFormControlViewModel,
      | 'disabled'
      | 'invalid'
      | 'lengthInBytes'
      | 'maxLength'
      | 'name'
      | 'readonly'
      | 'required'
      | 'tree'
      | 'value'
    >,
    Pick<TextInputProps, 'onChange' | 'onChanged'> {
  formId: UniqueId;
  onRunSingleUpdater?: (updaterName?: TUpdaterName) => void;
}

const mapDispatchToProps = {
  openDisplayMode: categoryActions.openDisplayMode,
};

const mergeProps = (
  _sP: null,
  { openDisplayMode }: typeof mapDispatchToProps,
  { tree, onRef: containerRef, formId, name, ...oP }: Props
) => ({
  ...oP,
  containerRef,
  icon: 'tree' as IconName,
  onButtonClick: () =>
    openDisplayMode({
      category: tree.Category,
      displayMode: tree.DisplayMode,
      ui: {
        mode: CategoryOpenMode.TREE,
        tree,
        effect: {
          type: DictionaryEffectType.UPDATE_WITH_OUT_PARAMS,
          field: name,
          form: formId,
        },
      },
    }),
});

const connector = connect(null, mapDispatchToProps, mergeProps, {
  forwardRef: true,
});

export type TLookupBoxTreeConnectorProps = ConnectedProps<typeof connector>;

export default connector(LookupBox);
